export const orgList = [
    {
        activeTab: '1',
        img: 'user/user.png',
        name: 'Neo Molapisi',
        email: 'DPSM - Directorate of Public Servcie Management',
		omang: '537352222',
        gender: 'Male'
    },
    {
        activeTab: '2',
        img: 'user/user.png',
        name: 'Kabelo Mmono',
        email: 'DRTS - Department of Road Transport Services',
		omang: '9742222',
        gender: 'Male'
    },
    {
        activeTab: '3',
        img: 'user/user.png',
        name: 'David Modise',
        email: 'BPS - Botswana Police Service',
		omang: '13673552',
        gender: 'Female'
    },
    {
        activeTab: '4',
        img: 'user/user.png',
        name: 'Kebalepile Sekgoma',
        email: 'DIC - Department of Immigration & Citizenship',
		omang: '965223434',
        gender: 'Female'
    }
]